<template>
	<div>
		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			:title-is-bold="false"
			:grid-ref="gridRef"
			v-bind:row-href="rowHref"
			defaultOrderBy="updated_at"
			:defaultOrderByAscending="false"
		/>
	</div>
</template>
<script>
let options = require("../../cropOptions");
export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {
		title() {
			return this.__("Ongoing Negotiations");
		},
	},
	data() {
		let routeName = null;
		if (this.form.trade == "BUY") {
			routeName = "admin.offers_buy_negotiation";
		} else if (this.form.trade == "SELL") {
			routeName = "admin.offers_sell_negotiation";
		}
		return {
			gridRef: {
				link: this.$route(routeName, {
					id: this.form.id,
					iframe_modal: 1,
				}),
				label: this.__("Start a new negotiation"),
			},
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "status",
					name: this.__("Status"),
					filterOptions: options.threadStatusOptions.map((f) => {
						return { id: this.__(f.name), name: this.__(f.name) };
					}),
					render: (status, tradable) =>
						window.__(options.getLabel(status, options.threadStatusOptions)),
				},
				{
					id: "product__grade",
					name: this.__("Article"),
					filterOptions: Object.values(options.productGradeOptions)
						.flat()
						.map((o) => {
							return {
								id: this.__(o.name),
								name: this.__(o.name),
							};
						}),
					render: (x, row) =>
						window.__(
							options.getLabel(
								row.last_tradable.product__grade,
								options.productGradeOptions
							)
						),
				},
				{
					id: "product__harvest",
					name: this.__("Harvest"),
					render: (x, row) => row.last_tradable.product__harvest,
				},
				{
					id: "qty__mt",
					name: this.__("Quantity"),
					render: (x, row) => row.last_tradable.qty__mt,
				},
				{
					id: "price__mt",
					name: this.__("Price"),
					render: (x, row) => row.last_tradable.price__mt,
				},
				{
					id: "location_mode",
					name: this.__("Location"),
					render: (x, row) =>
						window.__(
							options.getLabel(
								row.last_tradable.location__mode,
								options.locationModeOptions
							)
						),
				},
				{
					id: "location",
					name: this.__("City"),
					render: (x, row) => window.__(row.last_tradable.location__desc),
				},
				{
					id: "date_mode",
					name: this.__("Fulfilment Date"),
					render: (x, row) =>
						window.__(
							options.getLabel(
								row.last_tradable.date__type,
								options.dateModeOptions
							)
						),
				},
				{
					id: "date_range",
					name: this.__("Period "),
					render: (x, row) => row.last_tradable.date__desc,
				},
				{
					id: "seller_company_name",
					name: this.__("Seller"),
					render: (x, row) =>
						row.seller.company_name + (row.started_by == "SELLER" ? "*" : ""),
				},
				{
					id: "buyer_company_name",
					name: this.__("Buyer"),
					render: (x, row) =>
						row.buyer.company_name + (row.started_by == "BUYER" ? "*" : ""),
				},
				{
					id: "updated_at",
					name: this.__("Updated"),
					render: (x, row) => options.formatIsoStamp(row.updated_at),
				},
				{
					id: "seller__type",
					name: this.__("Seller (type)"),
					render: (x, row) =>
						window.__(
							options.getLabel(row.seller.type, options.companyTypeOptions)
						),
				},
				{
					id: "buyer__type",
					name: this.__("Buyer (type)"),
					render: (x, row) =>
						window.__(
							options.getLabel(row.buyer.type, options.companyTypeOptions)
						),
				},
				{
					id: "seller__id",
					name: this.__("Seller (ID)"),
					render: (x, row) => row.seller.id,
				},
				{
					id: "buyer__id",
					name: this.__("Buyer (ID)"),
					render: (x, row) => row.buyer.id,
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: (x, row) => options.formatIsoStamp(row.created_at),
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return window.baseUrl + "/admin/threads/" + row.id.substr(1);
		},
	},
};
</script>
